import { get, post } from '@/utils/request';
export const bcdls = (params) => {
  return get('/api/v1/bcdls', params);
};


export const bcdlsByPuser = (params) =>
 get('/api/v1/api/v1/bcdls', { params });

export const bcdl = (id) => get(`/api/v1/m/bcdl/${id}`);


export const bind_contract = (data) =>
  post(`/api/v1/bind_contract`, data);

export const review = (data) =>
  post(`/api/v1/contract_review`, data);